import Vue from 'vue'

import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'

Vue.use(SlimDialog)

const slimDialogStyle = document.createElement('style')
slimDialogStyle.setAttribute('data-v-slim-dialog-fix', 'true')
slimDialogStyle.textContent = `
  .v-dialog,
  .v-dialog.active,
  .v-dialog:target {
    z-index: 2200 !important;
  }

  .v-dialog .v-dialog-overlay {
    z-index: 2199 !important;
  }

  .v-dialog .v-dialog-container {
    z-index: 2201 !important;
  }
`

if (!document.head.querySelector('[data-v-slim-dialog-fix="true"]')) {
  document.head.appendChild(slimDialogStyle)
}